import classNames from '@/utils/classNames';
import type { FCl } from 'react-fc';
import styles from './SkeletonPulse.module.css';

interface IProps {
    lines?: number;
}

export const SkeletonPulse: FCl<IProps> = ({ className, lines = 3 }) => {
    return (
        <div className={classNames(styles.Container, className)}>
            {Array.from({ length: lines }).map((_, i) => (
                <div key={i} className={classNames(styles.SkeletonPulse, styles.PulseLine)} />
            ))}
        </div>
    );
};
